import { registerPlugin } from '@capacitor/core';
const CapacitorZebraPrinter = registerPlugin('CapacitorZebraPrinter', {
    web: () => import('./web').then(m => new m.CapacitorZebraPrinterWeb()),
});
export * from './definitions';
export { CapacitorZebraPrinter };
//# sourceMappingURL=index.js.map